import qwest from 'qwest';

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let CustomerEmailPref = {
  getPrefs(email) {
    return qwest.get(`/CustomerEmailPrefs/GetPreferences?email=${email}`)
      .then(onSuccess(), onError);
  },
};

export default CustomerEmailPref;
